import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { API_ENDPOINT } from "../../config";

export interface SalesReportResponse {
  success: boolean;
  financial_year: string;
  period: {
    start_date: string;
    end_date: string;
  };
  summary: {
    total_sales: number;
    total_transactions: number;
  };
  breakdown: {
    by_purpose: Array<{
      purpose: string;
      amount: number;
      count: number;
      percentage: number;
    }>;
    by_payment_method: Array<{
      method: string;
      amount: number;
      count: number;
      percentage: number;
    }>;
    by_gateway: Array<{
      gateway: string;
      amount: number;
      count: number;
      percentage: number;
    }>;
  };
  monthly_trend: Array<{
    month: string;
    amount: number;
    count: number;
  }>;
}

export const salesReportApi = createApi({
  reducerPath: "salesReportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/admin/payment",
    credentials: "include",
  }),
  tagTypes: ['SalesReport'],
  endpoints: (build) => ({
    getSalesReport: build.query<SalesReportResponse, string>({
      query: (financialYear) => ({
        url: `/sales-report?financial_year=${financialYear}&_t=${Date.now()}`,
        method: "GET",
      }),
      providesTags: (result, error, financialYear) => [
        { type: 'SalesReport', id: financialYear }
      ],
    }),
  }),
});

export const { useGetSalesReportQuery, useLazyGetSalesReportQuery } = salesReportApi;

